import { frMessages } from './lib/intl/en-US';

export const programId = '5e90d94f0a95781d57bcbb4f';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    useFingerprinting: true,
    logLevel: 'error',
    messagesWithLocale: {
        'en-US': frMessages,
    },
};
